import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";

export function PageEditDialog({
  editingPage, setEditingPage, siteSettings, setSiteSettings,
  saveSiteSettings, saving,
}) {
  return (
    <Dialog open={!!editingPage} onOpenChange={() => setEditingPage(null)}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto rounded-3xl">
        <DialogHeader>
          <DialogTitle>Edit {siteSettings.pages?.[editingPage]?.title || "Page"}</DialogTitle>
        </DialogHeader>
        {editingPage && (
          <div className="space-y-4">
            <div className="space-y-2">
              <Label>Page Title</Label>
              <Input
                value={siteSettings.pages?.[editingPage]?.title || ""}
                onChange={e => setSiteSettings(prev => ({
                  ...prev,
                  pages: { ...prev.pages, [editingPage]: { ...prev.pages[editingPage], title: e.target.value } }
                }))}
                className="rounded-xl"
                data-testid="page-edit-title"
              />
            </div>
            <div className="space-y-2">
              <Label>Content</Label>
              <p className="text-xs text-gray-400">Use **bold text** for headings, and - for bullet points</p>
              <Textarea
                value={siteSettings.pages?.[editingPage]?.content || ""}
                onChange={e => setSiteSettings(prev => ({
                  ...prev,
                  pages: { ...prev.pages, [editingPage]: { ...prev.pages[editingPage], content: e.target.value } }
                }))}
                rows={15}
                className="rounded-xl font-mono text-sm"
                data-testid="page-edit-content"
              />
            </div>
            <Button onClick={() => { saveSiteSettings(); setEditingPage(null); }} disabled={saving} className="rounded-xl" data-testid="page-edit-save">
              {saving ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null} Save Page
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
